document.addEventListener('DOMContentLoaded', function () {
    var videoContainers = document.querySelectorAll('.merlin-video-container');

    videoContainers.forEach(function (videoContainer) {
        var videoUrl = videoContainer.getAttribute('data-video-url');
        var videoThumbnail = videoContainer.getAttribute('data-video-thumbnail');

        if (!videoContainer || !videoUrl || videoThumbnail) return;

        var bgImage = '';
        var isYoutube = videoContainer.getAttribute('data-is-youtube').toLowerCase() === 'true';

        if (isYoutube) {
            bgImage = 'https://img.youtube.com/vi/' + videoUrl + '/hqdefault.jpg';
        }
        else {
            fetch('https://api.vimeo.com/videos/' + videoUrl, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer 719a1b1f729c31c8e2922abb4446ac02'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data && data.pictures && data.pictures.sizes && data.pictures.sizes.length > 0) {
                        bgImage = data.pictures.sizes[data.pictures.sizes.length - 1].link;
                    }
                    videoContainer.style.backgroundImage = 'url(' + bgImage + ')';
                    videoContainer.style.backgroundSize = 'cover';
                    videoContainer.style.backgroundRepeat = 'no-repeat';
                })
                .catch(error => console.error('Error fetching Vimeo thumbnail:', error));
        }

        if (bgImage) {
            videoContainer.style.backgroundImage = 'url(' + bgImage + ')';
            videoContainer.style.backgroundSize = 'cover';
            videoContainer.style.backgroundRepeat = 'no-repeat';
        }
    });
});
